<div class="p-grid w-100 d-flex justify-content-between">
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<i class="pi pi-shopping-cart"></i>
				</span>
				<span class="overview-title">Active Subscriptions</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						{{ customerService.customerSubscriptionItemList.value.length }}
					</div>
					<div class="overview-subtext">Total active subscriptions</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'user-crown']"></fa-icon>
				</span>
				<span class="overview-title">Unique Customers</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						{{ uniqueSubscribers.length }}
					</div>
					<div class="overview-subtext">Unique customers with subscriptions</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<i class="pi pi-shopping-cart"></i>
				</span>
				<span class="overview-title">Due Subscriptions</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="col-4">
					<div class="overview-number">
						{{ dueRange.today }}
					</div>
					<div class="overview-subtext">Today</div>
				</div>
				<div class="col-4">
					<div class="overview-number">
						{{ dueRange.tomorrow }}
					</div>
					<div class="overview-subtext">Tomorrow</div>
				</div>
				<div class="col-4">
					<div class="overview-number">
						{{ dueRange.thisWeek }}
					</div>
					<div class="overview-subtext">This week</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="p-grid w-100 d-flex justify-content-between">
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-2">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'clock']"></fa-icon>
				</span>
				<span class="overview-title">Due Today</span>
			</div>
			<div class="p-grid overview-detail">
				<ng-container *ngFor="let item of dueRange.dueTodayItems" class="overview-subtext">
					<div class="col-2">
						{{ item.quantity }}
					</div>
					<div class="col-10 p-text-left">
						{{ item.item }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-3">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'clock']"></fa-icon>
				</span>
				<span class="overview-title">Due Tomorrow</span>
			</div>
			<div class="p-grid overview-detail">
				<ng-container *ngFor="let item of dueRange.dueTomorrowItems" class="overview-subtext">
					<div class="col-2">
						{{ item.quantity }}
					</div>
					<div class="col-10 p-text-left">
						{{ item.item }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-4">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'clock']"></fa-icon>
				</span>
				<span class="overview-title">Due This Week</span>
			</div>
			<div class="p-grid">
				<div *ngFor="let item of dueRange.dueThisWeekItems" class="overview-subtext">
					<div class="col-2">
						{{ item.quantity }}
					</div>
					<div class="col-10 p-text-left">
						{{ item.item }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
